// 브라우저에서 난 오류를 Sentry 로 보낸다.
//
// - Sentry SDK 는 처음 보고할 때 동적으로 불러온다. 모든 지면의 번들에 넣지 않기 위해서다.
// - 전역 Sentry.init 대신 독립 클라이언트를 쓴다. window.onerror 같은 전역 핸들러를 걸지 않으므로
//   reportError 로 넘긴 오류만 간다(페이지의 다른 스크립트·광고 오류는 수집하지 않는다).
// - production 빌드에서만 보낸다. 개발·테스트에서는 콘솔에만 남긴다.
// - DSN 은 서버(config/initializers/sentry.rb)와 같은 noonnu 프로젝트다. 이벤트의 platform 이
//   javascript 로 찍혀 서버 오류와 구분된다.
const DSN = "https://5b025f2d8f12492287b501016b8198d4@o439720.ingest.sentry.io/5810134";
const ENABLED = import.meta.env.MODE === "production";

let scopePromise;

export function reportError(error, { tags = {}, extra = {} } = {}) {
  console.error("[reportError]", error, { tags, extra });
  if (!ENABLED) return;

  loadScope()
    .then((scope) => {
      const eventScope = scope.clone();
      eventScope.setTags(tags);
      eventScope.setExtras(extra);
      eventScope.captureException(error);
    })
    .catch((sentryError) => console.error("[reportError] Sentry 전송 실패", sentryError));
}

function loadScope() {
  scopePromise ||= import("@sentry/browser").then((Sentry) => {
    const client = new Sentry.BrowserClient({
      dsn: DSN,
      environment: "production",
      transport: Sentry.makeFetchTransport,
      stackParser: Sentry.defaultStackParser,
      integrations: [Sentry.dedupeIntegration(), Sentry.linkedErrorsIntegration()],
    });
    const scope = new Sentry.Scope();
    scope.setClient(client);
    client.init();
    return scope;
  });
  scopePromise.catch(() => { scopePromise = null; });
  return scopePromise;
}
